<template>
  <modal :name="nameModal" class="modal-submit-drafts" :width="'30%'" :height="'auto'" :scrollable="true" @before-open="beforeOpen" @before-close="beforeClose">
    <div class="modal-header border-0 justify-content-end pb-0">
      <div class="modal-close-img" @click="onCancel()" @mouseover="isHoverClose = true"
           @mouseleave="isHoverClose = false">
        <img src="../../../static/img/info-modal-close.svg" alt="close" v-if="!isHoverClose">
        <img src="../../../static/img/info-modal-close-hover.svg" alt="close" v-if="isHoverClose">
      </div>
    </div>
    <div class="main-content">
      <p class="text-question">{{textQuestion}}</p>
      <p class="text-description" v-if="listTextDescription.length ==0 "><b>{{textDescription}}</b></p>
      <p class="text-description" v-else>
      <ul >
          <li v-for="(item, index) in listTextDescription" :key="index"><b>{{item}}</b></li>
      </ul>

      </p>
      
      <div class="btn-container">
        <b-button class="btn-cancel" @click="onCancel">
          Cancel
        </b-button>
        <b-button class="btn-submit" @click="onSubmit" :disabled="loadingCovidSelect">
          <b-spinner v-if="loadingCovidSelect"></b-spinner>
          Yes
        </b-button>
      </div>
    </div>
  </modal>
</template>
<script>
import _ from 'lodash';
export default {
  name: 'ModalChangeToggleVaccines',
  props: {
    onCheckToggleOnOff: Function,
    loadingCovidSelect: {
      type: Boolean,
      default: false
    },
    addOns: {
      type: Array,
      default: []
    },
    nameModal: String,
    textQuestion: String,
    textDescription: String,
    listTextDescription: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      obj: null
    }
  },
  methods: {
    beforeOpen (params) {
      if (!params.params) return;
      this.obj = params.params;
      this.loadingCovidSelect = false;
    },
    beforeClose () {
      this.onCancelToggle();
    },
    onCancel () {
      this.onCancelToggle();
      this.$modal.hide(this.nameModal);
    },
    onSubmit () {
      this.loadingCovidSelect = true;
      this.onCheckToggleOnOff(this.obj);
    },
    onCancelToggle () {
      if (this.loadingCovidSelect) return;
      let addOn = _.find(this.addOns, {'key': this.obj.key});
      addOn.value = !this.obj.isAdd;
    }
  }
}
</script>


// WEBPACK FOOTER //
// ModalChangeToggleVaccines.vue?16ed0e43